/**
 * Moast → 主题快购桥接（方案 C）
 * Moast 使用 closed Shadow DOM，通过 composedPath / 点击坐标 / 面板兜底解析产品
 */
(function () {
  var BLOCK_SELECTOR = '.shopify-app-block[id*="moast"]';
  var MOAST_TAGS = [
    "MOAST-PRODUCTS",
    "MOAST-CAROUSEL",
    "MOAST-PLAYER",
    "MOAST-PRODUCT",
    "MOAST-QUICK-ADD",
  ];
  var MOAST_PANEL_SELECTORS =
    "moast-quick-add, moast-product-panel, moast-slide-out, moast-product-details, moast-drawer, [class*='slide-out'], [class*='product-panel'], [class*='moast'][class*='drawer'], dialog";
  var SKIP_ATTRS = {
    "block-id": 1,
    "feed-id": 1,
    id: 1,
    class: 1,
    style: 1,
    type: 1,
    role: 1,
    name: 1,
    slot: 1,
    part: 1,
    tabindex: 1,
    "data-moast-quick-shop-bound": 1,
  };

  var ALLOWED_PRODUCT_ATTRS = {
    product: 1,
    "product-handle": 1,
    "data-product-handle": 1,
    "data-product": 1,
    handle: 1,
  };

  var BLOCKED_HANDLES = {
    button: 1,
    submit: 1,
    reset: 1,
    text: 1,
    click: 1,
    cart: 1,
    slide: 1,
    cards: 1,
    product: 1,
    carousel: 1,
    moast: 1,
    true: 1,
    false: 1,
    none: 1,
    all: 1,
    add: 1,
    link: 1,
    open: 1,
    close: 1,
    primary: 1,
    secondary: 1,
    hidden: 1,
    visible: 1,
  };

  var productCache = new Map();
  var titleCache = new Map();
  var openLock = false;
  var panelHijackLock = false;
  var panelGuardTimer = null;
  var lastBarActionAt = 0;
  var cartButtonClickPending = false;
  var cartButtonPendingTimer = null;
  var lastOpenKey = "";
  var lastOpenAt = 0;
  /** 低于站点 Header（z-index ~200），避免加购按钮盖住导航 */
  var CART_BUTTON_Z_INDEX = 15;

  /** 产品条在 slide 中的大致位置比例，可按实际 UI 微调 */
  var PRODUCT_BAR_TOP_RATIO = 0.82;
  /** 右侧购物车按钮区域（黄色框）占 slide 宽度的比例 */
  var CART_BUTTON_LEFT_RATIO = 0.78;
  var CART_BUTTON_SIZE = 20;

  /**
   * 购物车按钮图标类型：
   * - "bag"  使用主题 iconfont（icon-Shopping-bag）
   * - "svg"  使用下方 CART_BUTTON_SVG 自定义 SVG
   *
   * 加购按钮使用 Shadow 内 .product__action（随 moast-products / 页面滚动，无 fixed 浮层抖闪）。
   */
  var CART_BUTTON_ICON = "svg";
  var CART_BUTTON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M20.7404 6.85986L22.0004 15.1999C22.5104 18.8499 20.0004 22.1699 16.6004 22.1999H7.34036C4.00036 22.1999 1.46036 18.8499 2.00036 15.1999L3.26036 6.85986C3.55948 4.10223 5.82903 1.97719 8.60036 1.85986H15.4004C18.1717 1.97719 20.4412 4.10223 20.7404 6.85986ZM16.6304 20.6699C17.7041 20.6544 18.7168 20.1681 19.4004 19.3399C20.3171 18.2542 20.715 16.8229 20.4904 15.4199L19.2604 7.07986C19.0847 5.04415 17.4403 3.44659 15.4004 3.32986H8.60036C6.56042 3.44659 4.91599 5.04415 4.74036 7.07986L3.51036 15.4199C3.28567 16.8229 3.68365 18.2542 4.60036 19.3399C5.28387 20.1681 6.29662 20.6544 7.37036 20.6699H16.6304Z" fill="currentColor"/>' +
    '<path d="M15.1504 7.05986C14.7361 7.05986 14.4004 7.39565 14.4004 7.80986C14.4004 9.13535 13.3258 10.2099 12.0004 10.2099C10.6749 10.2099 9.60036 9.13535 9.60036 7.80986C9.60036 7.39565 9.26457 7.05986 8.85036 7.05986C8.43614 7.05986 8.10036 7.39565 8.10036 7.80986C8.10036 9.2032 8.84369 10.4907 10.0504 11.1874C11.257 11.884 12.7437 11.884 13.9504 11.1874C15.157 10.4907 15.9004 9.2032 15.9004 7.80986C15.895 7.3979 15.5623 7.06525 15.1504 7.05986Z" fill="currentColor"/>' +
    "</svg>";

  var cartButtonMap = new WeakMap();
  var shadowObserverFlags = new WeakMap();
  var cartButtonSyncRaf = 0;
  var productJsonCache = Object.create(null);
  var comparePricePending = new WeakSet();

  if (typeof window !== "undefined") {
    window.MoastQuickShopConfig = window.MoastQuickShopConfig || {};
    if (window.MoastQuickShopConfig.icon) {
      CART_BUTTON_ICON = window.MoastQuickShopConfig.icon;
    }
    if (window.MoastQuickShopConfig.svg) {
      CART_BUTTON_SVG = window.MoastQuickShopConfig.svg;
    }
  }

  function getCartButtonIconHtml() {
    if (CART_BUTTON_ICON === "svg") return CART_BUTTON_SVG;
    return '<span class="iconfont icon-Shopping-bag" aria-hidden="true"></span>';
  }

  function refreshCartButtonIcons() {
    // 清掉历史 fixed 浮层，避免滚动鬼影
    document.querySelectorAll(".moast-theme-cart-btn").forEach(function (btn) {
      btn.remove();
    });

    getMoastProductElements().forEach(function (productEl) {
      var root = getShadowRootDeep(productEl);
      if (!root) return;
      patchMoastProductActionIcon(root.querySelector(".product__action"));
    });
  }

  function collectMoastProductsFromRoot(root, products, seen) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll("moast-product").forEach(function (el) {
      if (!seen.has(el)) {
        seen.add(el);
        products.push(el);
      }
    });

    root.querySelectorAll("*").forEach(function (el) {
      if (el.shadowRoot) {
        collectMoastProductsFromRoot(el.shadowRoot, products, seen);
      }
    });
  }

  function collectMoastAnchorsFromRoot(root, anchors, seen) {
    if (!root || !root.querySelectorAll) return;

    root
      .querySelectorAll(".product-wrapper, [class*='product-wrapper']")
      .forEach(function (el) {
        if (!seen.has(el)) {
          seen.add(el);
          anchors.push(el);
        }
      });

    root.querySelectorAll("*").forEach(function (el) {
      if (el.shadowRoot) {
        collectMoastAnchorsFromRoot(el.shadowRoot, anchors, seen);
      }
    });
  }

  function getMoastSearchRoots() {
    var roots = [];
    var block = getMoastBlock();
    var carousel = getMoastCarousel();
    var player = document.querySelector("moast-player");

    if (block) roots.push(block);
    if (carousel) {
      roots.push(carousel);
      if (carousel.shadowRoot) roots.push(carousel.shadowRoot);
    }
    if (player) {
      roots.push(player);
      if (player.shadowRoot) roots.push(player.shadowRoot);
    }

    return roots;
  }

  function filterOutermostElements(elements) {
    return elements.filter(function (el, _i, arr) {
      return !arr.some(function (other) {
        return other !== el && other.contains && other.contains(el);
      });
    });
  }

  function getMoastCartTargets() {
    var productSeen = new Set();
    var products = [];
    var roots = getMoastSearchRoots();

    // 优先收集 moast-product：Shadow 样式/加购按钮补丁更可靠
    roots.forEach(function (root) {
      collectMoastProductsFromRoot(root, products, productSeen);
    });

    if (!products.length) {
      document
        .querySelectorAll(BLOCK_SELECTOR + " moast-product, moast-carousel moast-product")
        .forEach(function (el) {
          if (!productSeen.has(el)) {
            productSeen.add(el);
            products.push(el);
          }
        });
    }

    // 可见尺寸过滤放宽：初始化时尚未 layout 的卡片也要能打补丁
    var sized = products.filter(function (el) {
      var rect = el.getBoundingClientRect();
      return rect.width > 8 && rect.height > 8;
    });
    if (sized.length) return sized;
    if (products.length) return products;

    // 兜底：部分结构只有 product-wrapper
    var wrappers = [];
    var wrapperSeen = new Set();
    roots.forEach(function (root) {
      collectMoastAnchorsFromRoot(root, wrappers, wrapperSeen);
    });

    return filterOutermostElements(wrappers).filter(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.width <= 8 || rect.height <= 8) return true; // 未 layout 也保留
      return !!(getShadowRootDeep(el) || (el.querySelector && el.querySelector("moast-product")));
    });
  }

  function getMoastProductElements() {
    return getMoastCartTargets();
  }

  function getShadowRootDeep(el) {
    if (!el) return null;

    if (el.tagName === "MOAST-PRODUCT" && el.shadowRoot) {
      return el.shadowRoot;
    }

    var moastProduct =
      (el.querySelector && el.querySelector("moast-product")) ||
      (el.shadowRoot && el.shadowRoot.querySelector("moast-product"));

    if (moastProduct && moastProduct.shadowRoot) {
      return moastProduct.shadowRoot;
    }

    if (el.shadowRoot) {
      var action = el.shadowRoot.querySelector(".product__action, button.product");
      if (action) return el.shadowRoot;
    }

    return null;
  }

  function getMoastProductNode(el) {
    if (!el) return null;
    if (el.tagName === "MOAST-PRODUCT") return el;
    if (el.querySelector) {
      var hit = el.querySelector("moast-product");
      if (hit) return hit;
    }
    if (el.shadowRoot) {
      return el.shadowRoot.querySelector("moast-product");
    }
    return null;
  }

  function getMoastProductAction(productEl) {
    var root = getShadowRootDeep(productEl);
    if (!root) return null;
    return root.querySelector(".product__action");
  }

  function isMoastActionVisible(actionEl) {
    if (!actionEl) return false;

    var style = getComputedStyle(actionEl);
    if (style.display === "none" || style.visibility === "hidden" || Number(style.opacity) === 0) {
      return false;
    }

    var rect = actionEl.getBoundingClientRect();
    return rect.width > 4 && rect.height > 4;
  }

  var MOAST_SHADOW_STYLE_ID = "moast-theme-action-fix";
  /** 改 Shadow 样式后递增，确保本地预览/部署后能覆盖旧注入 */
  var MOAST_SHADOW_CSS_VERSION = "product-bar-v28-title-lh";
  var MOAST_PLAYER_IMG_STYLE_ID = "moast-theme-player-img-34";
  var MOAST_PLAYER_IMG_CSS_VERSION = "player-img-3-4-v4-sale-price";

  /** 播放器内商品条：只改缩略图 3:4，不套用轮播定制卡片样式 */
  function isMoastProductInsidePlayer(el) {
    var node = el;
    while (node) {
      if (node.tagName === "MOAST-PLAYER") return true;
      if (node.closest) {
        try {
          if (node.closest("moast-player")) return true;
        } catch (e) {}
      }
      var root = node.getRootNode && node.getRootNode();
      if (root && root.host) {
        node = root.host;
        continue;
      }
      node = node.parentElement;
    }
    return false;
  }

  function getMoastPlayerImageOnlyCss() {
    // 原图约 80×80(1:1) → 保持宽 80，高按 3:4 ≈ 106.67；去掉插件默认 gap
    return (
      "button.product," +
      ".product {" +
      "  --image-height: 106.67px !important;" +
      "  gap: 0 !important;" +
      "  column-gap: 0 !important;" +
      "  row-gap: 0 !important;" +
      "}" +
      ".product__image," +
      ".product_image," +
      "button.product .product__image," +
      "button.product .product_image," +
      ".product .product__image," +
      ".product .product_image," +
      "img.product__image," +
      "img.product_image {" +
      "  aspect-ratio: 3 / 4 !important;" +
      "  width: 80px !important;" +
      "  height: 106.67px !important;" +
      "  min-height: 106.67px !important;" +
      "  max-height: 106.67px !important;" +
      "  object-fit: cover !important;" +
      "}" +
      ".product__title," +
      "button.product .product__title," +
      ".product .product__title," +
      "p.product__title {" +
      "  line-height: 22px !important;" +
      "}" +
      /* 区间价 → 售价 + 划线价（复用 patchMoastComparePrice） */
      ".product__price-max," +
      ".product__price-separator {" +
      "  display: none !important;" +
      "}" +
      ".product__price-compare," +
      "[data-moast-theme-compare] {" +
      "  display: inline !important;" +
      "  margin-left: 6px !important;" +
      "  text-decoration: line-through !important;" +
      "  opacity: 0.72 !important;" +
      "  font-weight: 400 !important;" +
      "}"
    );
  }

  function restoreMoastPlayerProductVisibility(productEl) {
    var host = getMoastProductNode(productEl) || productEl;
    if (!host) return;
    if (host.removeAttribute) {
      host.removeAttribute("data-moast-theme-ready");
      host.removeAttribute("data-moast-theme-shell");
    }
    if (host.style) {
      host.style.removeProperty("opacity");
      host.style.removeProperty("visibility");
      host.style.removeProperty("pointer-events");
    }
  }

  function patchMoastPlayerProductImageOnly(productEl) {
    try {
      var moastProduct = getMoastProductNode(productEl);
      var root = getShadowRootDeep(productEl);
      if (!root) return false;
      if (productEl.__moastShadowPatching) return false;
      productEl.__moastShadowPatching = true;

      try {
        // 去掉误套在播放器上的整套定制卡片样式
        var fullStyle = root.getElementById(MOAST_SHADOW_STYLE_ID);
        if (fullStyle) fullStyle.remove();
        restoreMoastPlayerProductVisibility(productEl);

        var style = root.getElementById(MOAST_PLAYER_IMG_STYLE_ID);
        if (!style) {
          style = document.createElement("style");
          style.id = MOAST_PLAYER_IMG_STYLE_ID;
          root.appendChild(style);
        }
        if (style.dataset.moastCssVer !== MOAST_PLAYER_IMG_CSS_VERSION) {
          style.dataset.moastCssVer = MOAST_PLAYER_IMG_CSS_VERSION;
          style.textContent = getMoastPlayerImageOnlyCss();
        }

        var productBtn = root.querySelector("button.product, .product");
        if (productBtn && productBtn.style) {
          // 清掉误写的透明底/深色字，恢复插件默认
          productBtn.style.removeProperty("background");
          productBtn.style.removeProperty("background-color");
          productBtn.style.removeProperty("color");
          productBtn.style.removeProperty("overflow");
          setImportantStyleIfChanged(productBtn, "--image-height", "106.67px");
          setImportantStyleIfChanged(productBtn, "gap", "0");
          setImportantStyleIfChanged(productBtn, "column-gap", "0");
          setImportantStyleIfChanged(productBtn, "row-gap", "0");
        }

        root
          .querySelectorAll(".product__title, p.product__title")
          .forEach(function (titleEl) {
            setImportantStyleIfChanged(titleEl, "line-height", "22px");
          });

        root
          .querySelectorAll(
            ".product__image, .product_image, img.product__image, img.product_image"
          )
          .forEach(function (img) {
            setImportantStyleIfChanged(img, "aspect-ratio", "3 / 4");
            setImportantStyleIfChanged(img, "width", "80px");
            setImportantStyleIfChanged(img, "height", "106.67px");
            setImportantStyleIfChanged(img, "min-height", "106.67px");
            setImportantStyleIfChanged(img, "max-height", "106.67px");
            setImportantStyleIfChanged(img, "object-fit", "cover");
          });

        // 尽早藏区间价，再异步补售价+划线价
        root
          .querySelectorAll(".product__price-max, .product__price-separator")
          .forEach(function (el) {
            setImportantStyleIfChanged(el, "display", "none");
          });
        patchMoastComparePrice(productEl);

        productEl.__moastThemeShellPatched = true;
        observeMoastProductShadow(moastProduct || productEl, root);
        return true;
      } finally {
        productEl.__moastShadowPatching = false;
      }
    } catch (err) {
      if (productEl) productEl.__moastShadowPatching = false;
      console.warn("[moast-quickshop] player image patch failed", err);
      return false;
    }
  }

  function getMoastShadowFixCss() {
    return (
      /* 宿主未就绪时整卡隐藏（配合 early-hide / carousel unready CSS） */
      ":host:not([data-moast-theme-ready='1']) {" +
      "  opacity: 0 !important;" +
      "  visibility: hidden !important;" +
      "}" +
      ":host([data-moast-theme-ready='1']) {" +
      "  opacity: 1 !important;" +
      "  visibility: visible !important;" +
      "}" +
      /* 区间价节点始终藏掉，避免就绪后仍露出 max */
      ".product__price-max," +
      ".product__price-separator {" +
      "  display: none !important;" +
      "}" +
      /* 设计稿：无底色圆角边框 + 标题；主图 3:4；价格与加购同一行两端对齐 */
      ":host {" +
      "  --moast-card-background: transparent !important;" +
      "  --moast-card-text: #011701 !important;" +
      "  --_card-background: transparent !important;" +
      "  --_card-text: #011701 !important;" +
      "}" +
      "button.product," +
      ".product {" +
      "  background: transparent !important;" +
      "  background-color: transparent !important;" +
      "  border-radius: 8px !important;" +
      "  border: 0.5px solid #DDD !important;" +
      "  color: #011701 !important;" +
      "  filter: none !important;" +
      "  backdrop-filter: none !important;" +
      "  display: grid !important;" +
      "  grid-template-columns: 48px minmax(0, 1fr) auto !important;" +
      "  grid-template-rows: auto auto !important;" +
      "  column-gap: 8px !important;" +
      "  row-gap: 2px !important;" +
      "  align-items: center !important;" +
      "  --image-height: 64px !important;" +
      "}" +
      ".product__image," +
      ".product_image," +
      "button.product .product__image," +
      "button.product .product_image," +
      ".product .product__image," +
      ".product .product_image," +
      "img.product__image," +
      "img.product_image {" +
      "  grid-column: 1 !important;" +
      "  grid-row: 1 / span 2 !important;" +
      "  width: 48px !important;" +
      "  height: 64px !important;" +
      "  min-height: 64px !important;" +
      "  max-height: 64px !important;" +
      "  aspect-ratio: 3 / 4 !important;" +
      "  object-fit: cover !important;" +
      "  border-radius: 4px !important;" +
      "  display: block !important;" +
      "}" +
      // info 拆开参与父级 grid，才能把价格与加购放到同一行
      ".product__info," +
      "button.product .product__info," +
      ".product .product__info {" +
      "  display: contents !important;" +
      "  min-height: 0 !important;" +
      "  padding: 0 !important;" +
      "  color: #011701 !important;" +
      "}" +
      ".product__title," +
      "button.product .product__title," +
      "button.product .product__name," +
      "button.product [class*='product__title']," +
      "button.product [class*='product__name']," +
      ".product .product__title," +
      ".product .product__name," +
      ".product [class*='product__title']," +
      ".product [class*='product__name'] {" +
      "  grid-column: 2 / -1 !important;" +
      "  grid-row: 1 !important;" +
      "  color: #000 !important;" +
      "  font-family: Karla, Arial, sans-serif !important;" +
      "  font-size: 12px !important;" +
      "  font-weight: 600 !important;" +
      "  line-height: 150% !important;" +
      "  margin: 0 !important;" +
      "  min-width: 0 !important;" +
      "  display: -webkit-box !important;" +
      "  overflow: hidden !important;" +
      "  text-overflow: ellipsis !important;" +
      "  white-space: normal !important;" +
      "  -webkit-line-clamp: 2 !important;" +
      "  line-clamp: 2 !important;" +
      "  -webkit-box-orient: vertical !important;" +
      "}" +
      ".product__price," +
      "button.product .product__price," +
      ".product .product__price {" +
      "  grid-column: 2 !important;" +
      "  grid-row: 2 !important;" +
      "  color: #011701 !important;" +
      "  font-family: Karla, Arial, sans-serif !important;" +
      "  font-size: 13px !important;" +
      "  font-weight: 400 !important;" +
      "  margin: 0 !important;" +
      "  min-width: 0 !important;" +
      "  white-space: nowrap !important;" +
      "  overflow: hidden !important;" +
      "  text-overflow: ellipsis !important;" +
      "  display: flex !important;" +
      "  align-items: baseline !important;" +
      "  gap: 6px !important;" +
      "}" +
      // 显示首档售价 + 划线原价；隐藏区间「最低价 - 最高价」
      ".product__price-max," +
      ".product__price-separator {" +
      "  display: none !important;" +
      "}" +
      ".product__price-regular {" +
      "  display: inline !important;" +
      "  color: #011701 !important;" +
      "  font-size: 13px !important;" +
      "  font-weight: 600 !important;" +
      "  text-decoration: none !important;" +
      "  flex-shrink: 0 !important;" +
      "}" +
      ".product__price-compare," +
      ".product__compare-at-price," +
      "[data-moast-theme-compare] {" +
      "  display: inline !important;" +
      "  color: #b5b5b5 !important;" +
      "  font-size: 13px !important;" +
      "  font-weight: 400 !important;" +
      "  text-decoration: line-through !important;" +
      "  opacity: 1 !important;" +
      "  flex-shrink: 1 !important;" +
      "  min-width: 0 !important;" +
      "  overflow: hidden !important;" +
      "  text-overflow: ellipsis !important;" +
      "}" +
      "@media screen and (max-width: 768px) {" +
      "  .product__price," +
      "  button.product .product__price," +
      "  .product .product__price," +
      "  .product__price-regular," +
      "  .product__price-compare," +
      "  .product__compare-at-price," +
      "  [data-moast-theme-compare] {" +
      "    font-size: 12px !important;" +
      "  }" +
      "}" +
      ".variant__title," +
      "moast-rating {" +
      "  display: none !important;" +
      "}" +
      // Moast 在 @container max-width:300px 会隐藏加购，强制始终显示
      ".product__action," +
      "button.product .product__action," +
      ".product .product__action {" +
      "  grid-column: 3 !important;" +
      "  grid-row: 2 !important;" +
      "  display: flex !important;" +
      "  visibility: visible !important;" +
      "  opacity: 1 !important;" +
      "  pointer-events: auto !important;" +
      "  align-items: center !important;" +
      "  justify-content: center !important;" +
      "  justify-self: end !important;" +
      "  width: 20px !important;" +
      "  height: 20px !important;" +
      "  min-width: 20px !important;" +
      "  padding: 0 !important;" +
      "  flex-shrink: 0 !important;" +
      "  border-radius: 0 !important;" +
      "  background: transparent !important;" +
      "  color: #011701 !important;" +
      "}" +
      ".product__action svg {" +
      "  width: 18px !important;" +
      "  height: 18px !important;" +
      "  display: block !important;" +
      "  fill: #011701 !important;" +
      "  color: #011701 !important;" +
      "}" +
      "@container (max-width: 930px)," +
      "@container (max-width: 300px)," +
      "@container (max-width: 210px)," +
      "@container (max-width: 130px) {" +
      "  .product__action {" +
      "    display: flex !important;" +
      "    visibility: visible !important;" +
      "    opacity: 1 !important;" +
      "    width: 20px !important;" +
      "    height: 20px !important;" +
      "  }" +
      "  .product__image," +
      "  .product_image," +
      "  img.product__image," +
      "  img.product_image {" +
      "    display: block !important;" +
      "    aspect-ratio: 3 / 4 !important;" +
      "    width: 48px !important;" +
      "    height: 64px !important;" +
      "    min-height: 64px !important;" +
      "    max-height: 64px !important;" +
      "    object-fit: cover !important;" +
      "  }" +
      "  button.product," +
      "  .product {" +
      "    display: grid !important;" +
      "    width: 100% !important;" +
      "    max-width: none !important;" +
      "    border-radius: 8px !important;" +
      "    padding: 6px 8px 6px 0 !important;" +
      "  }" +
      "}" +
      // PC 两行省略，移动端单行省略（勿在字符串拼接中用 /* */ +，会变成 NaN）
      "@media screen and (max-width: 768px) {" +
      "  .product__title," +
      "  button.product .product__title," +
      "  button.product .product__name," +
      "  button.product [class*='product__title']," +
      "  button.product [class*='product__name']," +
      "  .product .product__title," +
      "  .product .product__name," +
      "  .product [class*='product__title']," +
      "  .product [class*='product__name'] {" +
      "    display: block !important;" +
      "    white-space: nowrap !important;" +
      "    -webkit-line-clamp: unset !important;" +
      "    line-clamp: unset !important;" +
      "    -webkit-box-orient: unset !important;" +
      "  }" +
      "}"
    );
  }

  function patchMoastProductActionIcon(actionEl) {
    if (!actionEl) return;

    var key = CART_BUTTON_ICON + ":" + CART_BUTTON_SVG.length;
    if (actionEl.dataset.moastThemeIconKey === key) return;

    actionEl.dataset.moastThemeIconKey = key;
    actionEl.innerHTML = getCartButtonIconHtml();
  }

  function ensureMoastProductAction(root) {
    if (!root) return null;
    var action = root.querySelector(".product__action");
    if (action) return action;

    var productBtn = root.querySelector("button.product, .product");
    if (!productBtn) return null;

    action = document.createElement("div");
    action.className = "product__action";
    action.setAttribute("data-moast-theme-action", "1");
    productBtn.appendChild(action);
    return action;
  }

  function setImportantStyleIfChanged(el, prop, value) {
    if (!el || !el.style) return false;
    if (
      el.style.getPropertyValue(prop) === value &&
      el.style.getPropertyPriority(prop) === "important"
    ) {
      return false;
    }
    el.style.setProperty(prop, value, "important");
    return true;
  }

  function markMoastProductShellReady(productEl, root) {
    if (!productEl) return;
    var host = getMoastProductNode(productEl) || productEl;
    if (host && host.setAttribute) {
      host.setAttribute("data-moast-theme-shell", "1");
    }
    // 结构（样式+加购）就绪即可显示条；价格行仍由 ready 控制，避免区间价闪现
    if (root) {
      var action = root.querySelector(".product__action");
      if (action) {
        setImportantStyleIfChanged(action, "visibility", "visible");
        setImportantStyleIfChanged(action, "opacity", "1");
      }
    }
  }

  function hideMoastProductUntilReady(productEl) {
    if (!productEl) return;
    var host = getMoastProductNode(productEl) || productEl;
    if (!host || !host.style) return;
    if (host.getAttribute && host.getAttribute("data-moast-theme-ready") === "1") {
      return;
    }
    setImportantStyleIfChanged(host, "opacity", "0");
    setImportantStyleIfChanged(host, "visibility", "hidden");
    setImportantStyleIfChanged(host, "pointer-events", "none");
  }

  function markMoastProductReady(productEl) {
    if (!productEl) return;
    var host = getMoastProductNode(productEl) || productEl;
    if (host && host.setAttribute) {
      host.setAttribute("data-moast-theme-ready", "1");
    }
    if (host && host.style) {
      setImportantStyleIfChanged(host, "opacity", "1");
      setImportantStyleIfChanged(host, "visibility", "visible");
      setImportantStyleIfChanged(host, "pointer-events", "auto");
    }
    if (productEl.__moastReadyFallback) {
      clearTimeout(productEl.__moastReadyFallback);
      productEl.__moastReadyFallback = null;
    }
  }

  function markMoastProductPriceReady(productEl) {
    markMoastProductReady(productEl);
  }

  function isMoastProductShellComplete(productEl) {
    var root = getShadowRootDeep(productEl);
    if (!root) return false;
    var style = root.getElementById(MOAST_SHADOW_STYLE_ID);
    if (!style || style.dataset.moastCssVer !== MOAST_SHADOW_CSS_VERSION) return false;
    if (!root.querySelector(".product__action")) return false;
    return true;
  }

  function ensureMoastProductReadyFallback(productEl) {
    if (!productEl || productEl.__moastReadyFallback) return;
    productEl.__moastReadyFallback = setTimeout(function () {
      productEl.__moastReadyFallback = null;
      patchMoastProductShadow(productEl);
      if (isMoastProductShellComplete(productEl)) {
        markMoastProductReady(productEl);
      }
    }, 1500);
  }

  function patchMoastProductShadow(productEl) {
    // 播放器底部条：只改缩略图 3:4，不套用轮播定制 UI
    if (isMoastProductInsidePlayer(productEl)) {
      return patchMoastPlayerProductImageOnly(productEl);
    }

    try {
      var moastProduct = getMoastProductNode(productEl);
      var root = getShadowRootDeep(productEl);
      if (!root) return false;

      // 未就绪先藏起来，避免首帧露出 Moast 默认区间价
      hideMoastProductUntilReady(productEl);

      // 重入保护：同一 product 同步补丁未结束时直接跳过
      if (productEl.__moastShadowPatching) return false;
      productEl.__moastShadowPatching = true;

      try {
        // 仅在首次或版本变更时写样式，避免 MutationObserver 因反复写 textContent 死循环
        var style = root.getElementById(MOAST_SHADOW_STYLE_ID);
        if (!style) {
          style = document.createElement("style");
          style.id = MOAST_SHADOW_STYLE_ID;
          root.appendChild(style);
        }
        if (style.dataset.moastCssVer !== MOAST_SHADOW_CSS_VERSION) {
          style.dataset.moastCssVer = MOAST_SHADOW_CSS_VERSION;
          style.textContent = getMoastShadowFixCss();
        }

        // 尽早藏区间价
        root
          .querySelectorAll(".product__price-max, .product__price-separator")
          .forEach(function (el) {
            setImportantStyleIfChanged(el, "display", "none");
          });

        var productBtn = root.querySelector("button.product, .product");
        if (productBtn) {
          setImportantStyleIfChanged(productBtn, "overflow", "visible");
          setImportantStyleIfChanged(productBtn, "background", "transparent");
          setImportantStyleIfChanged(productBtn, "background-color", "transparent");
          setImportantStyleIfChanged(productBtn, "color", "#011701");
          setImportantStyleIfChanged(productBtn, "--image-height", "64px");
        }

        // 缩略图强制 3:4（兼容 product__image / product_image）
        root
          .querySelectorAll(
            ".product__image, .product_image, img.product__image, img.product_image"
          )
          .forEach(function (img) {
            setImportantStyleIfChanged(img, "aspect-ratio", "3 / 4");
            setImportantStyleIfChanged(img, "width", "48px");
            setImportantStyleIfChanged(img, "height", "64px");
            setImportantStyleIfChanged(img, "min-height", "64px");
            setImportantStyleIfChanged(img, "max-height", "64px");
            setImportantStyleIfChanged(img, "object-fit", "cover");
          });

        var action = ensureMoastProductAction(root);
        if (action) {
          setImportantStyleIfChanged(action, "display", "flex");
          setImportantStyleIfChanged(action, "visibility", "visible");
          setImportantStyleIfChanged(action, "opacity", "1");
          setImportantStyleIfChanged(action, "pointer-events", "auto");
          setImportantStyleIfChanged(action, "width", "20px");
          setImportantStyleIfChanged(action, "height", "20px");
          setImportantStyleIfChanged(action, "min-width", "20px");
          setImportantStyleIfChanged(action, "background", "transparent");
          setImportantStyleIfChanged(action, "color", "#011701");
          patchMoastProductActionIcon(action);
        }

        markMoastProductShellReady(productEl, root);
        productEl.__moastThemeShellPatched = true;
        ensureMoastProductReadyFallback(productEl);

        // 关键：样式 + 加购就绪立即揭开（区间价已隐藏）。
        // 不要等价格接口——那会拉长空白，且上次用 textContent 判断区间价会卡死。
        if (isMoastProductShellComplete(productEl)) {
          markMoastProductReady(productEl);
        }

        // 划线价异步补上（此时已是右边样式，不会再闪左边）
        patchMoastComparePrice(productEl);

        observeMoastProductShadow(moastProduct || productEl, root);
        return isMoastActionVisible(action);
      } finally {
        productEl.__moastShadowPatching = false;
      }
    } catch (err) {
      if (productEl) productEl.__moastShadowPatching = false;
      console.warn("[moast-quickshop] shadow patch failed", err);
      return false;
    }
  }

  function observeMoastProductShadow(productEl, root) {
    if (!root) return;
    if (shadowObserverFlags.get(root)) return;
    shadowObserverFlags.set(root, true);

    var debounceTimer = null;
    // 绝不观察 style/class：patch 会写 inline style，观察 attributes 会在 iOS 上微任务死循环卡死整页
    new MutationObserver(function () {
      if (productEl.__moastShadowPatching) return;
      // 首次结构变化立刻补丁（避免左右滑看到旧样式）；后续合并防抖
      if (!productEl.__moastThemeShellPatched) {
        productEl.__moastThemeShellPatched = true;
        patchMoastProductShadow(productEl);
        return;
      }
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        if (productEl.__moastShadowPatching) return;
        patchMoastProductShadow(productEl);
      }, 80);
    }).observe(root, {
      childList: true,
      subtree: true,
    });
  }

  function syncMoastProductShadows() {
    getMoastProductElements().forEach(function (productEl) {
      patchMoastProductShadow(productEl);
    });
  }

  function injectHideMoastPanelCss() {
    var style = document.getElementById("moast-quickshop-hide-css");
    if (!style) {
      style = document.createElement("style");
      style.id = "moast-quickshop-hide-css";
      document.head.appendChild(style);
    }
    style.textContent =
      "body.moast-theme-quickshop-active moast-quick-add," +
      "body.moast-theme-quickshop-active moast-product-panel," +
      "body.moast-theme-quickshop-active moast-slide-out," +
      "body.moast-theme-quickshop-active moast-product-details," +
      "body.moast-theme-quickshop-active moast-drawer," +
      "body.moast-theme-quickshop-active [class*='moast'][class*='slide-out']," +
      "body.moast-theme-quickshop-active [class*='moast'][class*='slideout']," +
      "body.moast-theme-quickshop-active [class*='moast'][class*='product-panel']," +
      "body.moast-theme-quickshop-active [class*='moast'][class*='drawer']," +
      "body.moast-theme-quickshop-active [class*='moast'][class*='quick-add'] {" +
      "  display: none !important;" +
      "  visibility: hidden !important;" +
      "  pointer-events: none !important;" +
      "  opacity: 0 !important;" +
      "}" +
      /* Moast 播放器 z-index: 2147483645，主题快购默认 200，必须抬到之上 */
      "body.moast-theme-quickshop-active .quick_shop[aria-hidden='false'] {" +
      "  z-index: 2147483646 !important;" +
      "  pointer-events: none !important;" +
      "}" +
      "body.moast-theme-quickshop-active .quick_shop[aria-hidden='false'] .window-cover," +
      "body.moast-theme-quickshop-active .quick_shop[aria-hidden='false'] .quick_shop_main {" +
      "  pointer-events: auto !important;" +
      "}" +
      "body.moast-theme-quickshop-active .quick_shop[aria-hidden='false'] .window-cover {" +
      "  z-index: 1 !important;" +
      "}" +
      "body.moast-theme-quickshop-active .quick_shop[aria-hidden='false'] .quick_shop_main {" +
      "  z-index: 2 !important;" +
      "}" +
      /* Moast 场景下快购被抬到 2147483646；大图预览默认/快购态仅 1300，会被挡住 */
      "body.moast-theme-quickshop-active.is-quick-shop-media-zoom-open #MediaZoomModal.media-zoom-modal," +
      "body.moast-theme-quickshop-active #MediaZoomModal.media-zoom-modal.is-media-zoom-opening," +
      "body.moast-theme-quickshop-active #MediaZoomModal.media-zoom-modal[style*='display: block']," +
      "body.moast-theme-quickshop-active #MediaZoomModal.media-zoom-modal[style*='display:block'] {" +
      "  z-index: 2147483647 !important;" +
      "  pointer-events: auto !important;" +
      "}" +
      /*
       * 全屏 moast-player 打开时：站点 Header/Search 常因 stacking context
       * 盖在播放器之上（尤其透明顶栏），右上角静音/关闭点不到。
       * 注意：仅在实际打开时禁用 Header；Moast 会预挂载 moast-player 节点。
       */
      "body.moast-player-open .Header," +
      "body.moast-player-open .shopify-section-header," +
      "body.moast-player-open #shopify-section-header," +
      "body.moast-player-open .Search," +
      "body.moast-player-open .PageOverlay {" +
      "  pointer-events: none !important;" +
      "}" +
      "body.moast-player-open moast-player {" +
      "  pointer-events: auto !important;" +
      "  z-index: 2147483645 !important;" +
      "}";
  }

  function isMoastPlayerOpen(player) {
    player = player || getMoastPlayer();
    if (!player) return false;
    if (player.open === true) return true;

    var root = player.shadowRoot;
    if (!root) return false;
    var wrapper = root.querySelector(".player-wrapper");
    if (!wrapper) return false;
    return (
      wrapper.classList.contains("is-open") ||
      wrapper.getAttribute("aria-hidden") === "false"
    );
  }

  function syncMoastPlayerOpenClass() {
    document.body.classList.toggle("moast-player-open", isMoastPlayerOpen());
  }

  function bindMoastPlayerOpenState(player) {
    if (!player || player.dataset.moastOpenStateBound) return;
    player.dataset.moastOpenStateBound = "1";

    player.addEventListener("moast-player-open", syncMoastPlayerOpenClass);
    player.addEventListener("moast-player-close", syncMoastPlayerOpenClass);

    var root = player.shadowRoot;
    if (!root) return;
    var wrapper = root.querySelector(".player-wrapper");
    if (!wrapper || wrapper.dataset.moastOpenStateBound) return;
    wrapper.dataset.moastOpenStateBound = "1";
    new MutationObserver(syncMoastPlayerOpenClass).observe(wrapper, {
      attributes: true,
      attributeFilter: ["class", "aria-hidden"],
    });
  }

  function watchMoastPlayerOpenState() {
    if (watchMoastPlayerOpenState.__bound) return;
    watchMoastPlayerOpenState.__bound = true;
    bindMoastPlayerOpenState(getMoastPlayer());
    syncMoastPlayerOpenClass();
    new MutationObserver(function () {
      var wasOpen = document.body.classList.contains("moast-player-open");
      bindMoastPlayerOpenState(getMoastPlayer());
      syncMoastPlayerOpenClass();
      bindMoastPlayerClicks();
      var isOpen = document.body.classList.contains("moast-player-open");
      if (isOpen && !wasOpen) {
        scheduleSyncMoastCartButtons();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function injectMoastCartButtonCss() {
    var style = document.getElementById("moast-cart-btn-css");
    if (!style) {
      style = document.createElement("style");
      style.id = "moast-cart-btn-css";
      document.head.appendChild(style);
    }
    if (style.dataset.moastCssVer === "cart-btn-v11-no-fouc") return;
    style.dataset.moastCssVer = "cart-btn-v11-no-fouc";
    // fixed 浮层已废弃；未补丁完成的商品条先隐藏
    style.textContent =
      ".moast-theme-cart-btn {" +
      "  display: none !important;" +
      "  visibility: hidden !important;" +
      "  opacity: 0 !important;" +
      "  pointer-events: none !important;" +
      "  width: 0 !important;" +
      "  height: 0 !important;" +
      "}" +
      "moast-product:not([data-moast-theme-ready='1'])," +
      ".shopify-app-block[id*='moast'] moast-product:not([data-moast-theme-ready='1']) {" +
      "  opacity: 0 !important;" +
      "  visibility: hidden !important;" +
      "  pointer-events: none !important;" +
      "}" +
      "moast-product[data-moast-theme-ready='1'] {" +
      "  opacity: 1 !important;" +
      "  visibility: visible !important;" +
      "  pointer-events: auto !important;" +
      "}";
  }

  function markCartButtonClickPending() {
    cartButtonClickPending = true;
    document.body.classList.add("moast-theme-quickshop-active");
    if (cartButtonPendingTimer) clearTimeout(cartButtonPendingTimer);
    cartButtonPendingTimer = setTimeout(function () {
      cartButtonClickPending = false;
      if (!isThemeQuickShopOpen()) {
        document.body.classList.remove("moast-theme-quickshop-active");
      }
    }, 3500);
  }

  function isThemeQuickShopOpen() {
    var shell = document.querySelector(".quick_shop");
    var main = document.querySelector(".quick_shop_main");
    if (!main) return false;

    // 关闭态：不要被 quickShopLoading / :visible 误判成已打开
    if (shell && shell.getAttribute("aria-hidden") === "true") {
      return false;
    }

    if (shell && shell.getAttribute("aria-hidden") === "false") {
      var style = getComputedStyle(main);
      if (style.display === "none") return !!window.quickShopLoading;
      return true;
    }

    return !!window.quickShopLoading;
  }

  function resetMoastQuickShopLocks() {
    openLock = false;
    cartButtonClickPending = false;
    panelHijackLock = false;
    if (cartButtonPendingTimer) {
      clearTimeout(cartButtonPendingTimer);
      cartButtonPendingTimer = null;
    }
    if (!isThemeQuickShopOpen()) {
      document.body.classList.remove("moast-theme-quickshop-active");
      if (window.quickShopLoading) {
        window.quickShopLoading = false;
      }
    }
  }

  function getSiteHeaderBottom() {
    var header = document.querySelector(".Header, .shopify-section-header");
    if (!header) return 0;
    return header.getBoundingClientRect().bottom;
  }

  function isCartButtonOverlappingHeader(btnRect) {
    if (!btnRect) return false;
    var headerBottom = getSiteHeaderBottom();
    if (headerBottom <= 0) return false;
    return btnRect.top < headerBottom - 2;
  }

  function blockMoastNativeInteraction(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  function startMoastPanelGuard() {
    if (panelGuardTimer) {
      clearInterval(panelGuardTimer);
    }
    var count = 0;
    dismissMoastPanel();
    panelGuardTimer = setInterval(function () {
      dismissMoastPanel();
      count += 1;
      if (count >= 25) {
        clearInterval(panelGuardTimer);
        panelGuardTimer = null;
      }
    }, 100);
  }

  function getComposedPath(event) {
    return typeof event.composedPath === "function" ? event.composedPath() : [];
  }

  function getMoastCarousel() {
    return document.querySelector("moast-carousel");
  }

  /** 统一产品条背景：写在 host 上可继承进所有 moast-product Shadow DOM */
  function applyMoastCardThemeVars() {
    var carousel = getMoastCarousel();
    if (!carousel) return;
    carousel.style.setProperty("--moast-card-background", "transparent");
    carousel.style.setProperty("--moast-card-text", "#011701");
  }

  function getMoastBlock() {
    return (
      document.querySelector(BLOCK_SELECTOR) ||
      getMoastCarousel()?.closest(".shopify-app-block") ||
      getMoastCarousel()?.parentElement
    );
  }

  function isValidShopifyHandle(handle) {
    if (!handle || typeof handle !== "string") return false;
    var h = handle.trim().toLowerCase();
    if (!h || h.length < 8) return false;
    if (BLOCKED_HANDLES[h]) return false;
    if (/^\d+$/.test(h)) return false;
    if (
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(h)
    ) {
      return false;
    }
    if (!/[a-z]/.test(h)) return false;
    if (h.indexOf("-") < 0) return false;
    return true;
  }

  function toProduct(handle, source) {
    if (!isValidShopifyHandle(handle)) return null;
    return { href: "/products/" + handle, handle: handle, source: source || "unknown" };
  }

  function parseProductLink(href, source) {
    if (!href) return null;
    var handle =
      String(href)
        .trim()
        .match(/\/products\/([^/?#]+)/i)?.[1] || "";
    if (!handle) return null;
    handle = decodeURIComponent(handle).replace(/\.js$/i, "");
    return toProduct(handle, source || "link");
  }

  function parseHandleFromString(value, source) {
    if (!value) return null;
    var str = String(value).trim();
    if (!str) return null;
    if (str.indexOf("/products/") >= 0) return parseProductLink(str, source);
    return toProduct(str, source);
  }

  function canReadProductAttrsFromNode(node) {
    if (!(node instanceof Element)) return false;
    if (MOAST_TAGS.indexOf(node.tagName) >= 0) return true;
    if (node.hasAttribute("data-product-handle") || node.hasAttribute("product")) {
      return true;
    }
    return false;
  }

  function collectFromNode(node, results) {
    if (!(node instanceof Element)) return;

    if (node.tagName === "A") {
      var href = node.getAttribute("href") || node.href || "";
      var link = parseProductLink(href, "anchor");
      if (link) results.push(link);
      return;
    }

    if (!canReadProductAttrsFromNode(node) || !node.getAttributeNames) return;

    node.getAttributeNames().forEach(function (attr) {
      if (SKIP_ATTRS[attr]) return;
      if (!ALLOWED_PRODUCT_ATTRS[attr]) return;
      if (attr.indexOf("aria-") === 0) return;
      var parsed = parseHandleFromString(node.getAttribute(attr), "attr:" + attr);
      if (parsed) results.push(parsed);
    });
  }

  function pickBestProduct(results) {
    if (!results || !results.length) return null;
    var priority = ["search", "anchor", "panel-anchor", "attr:product", "attr:product-handle", "attr:data-product-handle", "panel-html"];
    for (var i = 0; i < priority.length; i++) {
      var hit = results.find(function (item) {
        return item.source === priority[i] && isValidShopifyHandle(item.handle);
      });
      if (hit) return hit;
    }
    return (
      results.find(function (item) {
        return (
          isValidShopifyHandle(item.handle) &&
          String(item.source || "").indexOf("attr:type") < 0
        );
      }) || null
    );
  }

  function cleanProductTitle(text) {
    if (!text) return "";
    return String(text)
      .replace(/\s+/g, " ")
      .replace(/\$[\d.,\s-]+.*$/i, "")
      .replace(/add to cart/gi, "")
      .trim();
  }

  function isValidSearchTitle(title) {
    if (!title || title.length < 8 || title.length > 220) return false;
    if (/block-id|feed-id|\.mp4|\.json|cdn\.shopify|"product":|https?:\/\//i.test(title)) {
      return false;
    }
    if (/[\[{}\]]/.test(title)) return false;
    if (!/[a-zA-Z]{3,}/.test(title)) return false;
    return true;
  }

  function sanitizeProductTitle(text) {
    var cleaned = cleanProductTitle(text);
    return isValidSearchTitle(cleaned) ? cleaned : "";
  }

  function getTitleFromProductButton(btn) {
    if (!btn) return "";
    var clone = btn.cloneNode(true);
    clone
      .querySelectorAll(".product__action, [class*='product__action']")
      .forEach(function (el) {
        el.remove();
      });
    return sanitizeProductTitle(clone.textContent || "");
  }

  function getTitleFromProductEl(productEl) {
    if (!productEl) return "";

    var root = getShadowRootDeep(productEl);
    if (!root) return "";

    var titleSelectors = [
      ".product__title",
      ".product-title",
      "[class*='product__title']",
      "[class*='product-title']",
      ".product__name",
      "[class*='product__name']",
    ];
    var i;
    for (i = 0; i < titleSelectors.length; i++) {
      var titleNode = root.querySelector(titleSelectors[i]);
      var titleText = sanitizeProductTitle(titleNode && titleNode.textContent);
      if (titleText) return titleText;
    }

    var productBtn = root.querySelector("button.product");
    var btnTitle = getTitleFromProductButton(productBtn);
    if (btnTitle) return btnTitle;

    return "";
  }

  function collectProductCandidatesFromElement(productEl, results) {
    if (!productEl) return;

    var nodes = [productEl, getMoastProductNode(productEl)];
    var root = getShadowRootDeep(productEl);
    var i;

    for (i = 0; i < nodes.length; i++) {
      if (nodes[i]) collectFromNode(nodes[i], results);
    }

    if (!root) return;

    root.querySelectorAll('a[href*="/products/"]').forEach(function (anchor) {
      collectFromNode(anchor, results);
    });
    root.querySelectorAll("moast-product").forEach(function (node) {
      collectFromNode(node, results);
    });
  }

  function resolveProductFromElement(productEl) {
    if (!productEl) return Promise.resolve(null);

    var fromNode = getProductDataFromMoastNode(productEl);
    if (fromNode && fromNode.handle) {
      return Promise.resolve(fromNode);
    }

    var results = [];
    collectProductCandidatesFromElement(productEl, results);
    var direct = pickBestProduct(results);
    if (direct) return Promise.resolve(direct);

    var title =
      (fromNode && fromNode.title) || getTitleFromProductEl(productEl);
    if (title) {
      return searchProductByTitle(title);
    }

    return Promise.resolve(null);
  }

  function openQuickShopFromProductEl(productEl, eventTarget) {
    markCartButtonClickPending();
    resolveProductFromElement(productEl).then(function (product) {
      if (!product) {
        console.warn("[moast-quickshop] 点击购物车按钮，未能解析产品", {
          target: eventTarget,
          title: getTitleFromProductEl(productEl),
        });
        return;
      }

      var block = getMoastBlock();
      if (window.MoastTopicTracking?.trackClickFromTarget && eventTarget) {
        window.MoastTopicTracking.trackClickFromTarget(eventTarget, block);
      }

      openThemeQuickShop(product);
    });
  }

  function extractTitleFromElement(el) {
    if (!el) return "";

    if (el instanceof Element && el.matches) {
      if (el.matches(".moast-theme-cart-btn, [data-moast-theme-cart]")) return "";
      if (el.closest && el.closest(".moast-theme-cart-btn, [data-moast-theme-cart]")) {
        return "";
      }
    }

    var text = sanitizeProductTitle(el.textContent || "");
    if (text.length >= 12) return text;

    var parent = el.parentElement;
    for (var i = 0; i < 4 && parent; i++) {
      text = sanitizeProductTitle(parent.textContent || "");
      if (text.length >= 12 && text.length < 220) return text;
      parent = parent.parentElement;
    }

    return "";
  }

  function getTitleFromProductRect(rect, productEl) {
    if (productEl) {
      var directTitle = getTitleFromProductEl(productEl);
      if (directTitle) return directTitle;
    }

    if (!rect) return "";

    var samplePoints = [
      [rect.left + rect.width * 0.35, rect.bottom - 14],
      [rect.left + rect.width * 0.5, rect.bottom - 14],
      [rect.left + rect.width * 0.25, rect.bottom - 14],
      [rect.left + rect.width * 0.35, rect.top + rect.height * 0.9],
    ];
    var i;
    for (i = 0; i < samplePoints.length; i++) {
      var hit = document.elementFromPoint(samplePoints[i][0], samplePoints[i][1]);
      if (
        hit instanceof Element &&
        hit.closest &&
        hit.closest(".moast-theme-cart-btn, [data-moast-theme-cart]")
      ) {
        continue;
      }
      var title = extractTitleFromElement(hit);
      if (title.length >= 12) return title;
    }

    return "";
  }

  function getTitleFromClick(event) {
    var path = getComposedPath(event);
    var i;
    var title = "";

    for (i = 0; i < path.length; i++) {
      if (
        path[i] instanceof Element &&
        (path[i].tagName === "MOAST-PRODUCTS" ||
          String(path[i].className || "").indexOf("product") >= 0)
      ) {
        title = extractTitleFromElement(path[i]);
        if (title.length >= 12) return title;
      }
    }

    var rect = getActiveSlideRect();
    if (rect) {
      var samplePoints = [
        [rect.left + rect.width * 0.35, rect.bottom - 18],
        [rect.left + rect.width * 0.5, rect.bottom - 18],
        [event.clientX - 40, event.clientY],
      ];
      for (i = 0; i < samplePoints.length; i++) {
        var hit = document.elementFromPoint(samplePoints[i][0], samplePoints[i][1]);
        title = extractTitleFromElement(hit);
        if (title.length >= 12) return title;
      }
    }

    var deep = document.elementFromPoint(event.clientX, event.clientY);
    if (deep) {
      title = extractTitleFromElement(deep);
      if (title.length >= 12) return title;
    }

    return "";
  }

  function searchProductByTitle(title) {
    var safeTitle = sanitizeProductTitle(title);
    if (!safeTitle) {
      return Promise.resolve(null);
    }

    var key = safeTitle.toLowerCase();
    if (titleCache.has(key)) {
      return Promise.resolve(titleCache.get(key));
    }

    var query = safeTitle.slice(0, 80);
    var url =
      "/search/suggest.json?q=" +
      encodeURIComponent(query) +
      "&resources[type]=product&resources[limit]=8";

    return fetch(url, {
      method: "GET",
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then(function (res) {
        if (!res.ok) throw new Error("search " + res.status);
        return res.json();
      })
      .then(function (data) {
        var products = data?.resources?.results?.products || [];
        if (!products.length) return null;

        var lower = safeTitle.toLowerCase();
        var picked =
          products.find(function (p) {
            return p.title && p.title.toLowerCase() === lower;
          }) ||
          products.find(function (p) {
            return (
              p.title &&
              (p.title.toLowerCase().indexOf(lower.slice(0, 28)) >= 0 ||
                lower.indexOf(p.title.toLowerCase().slice(0, 28)) >= 0)
            );
          }) ||
          products[0];

        if (!picked || !picked.handle) return null;
        var product = toProduct(picked.handle, "search");
        if (product) titleCache.set(key, product);
        return product;
      })
      .catch(function () {
        return null;
      });
  }

  function getProductDataFromMoastNode(node) {
    if (!node) return null;

    var candidates = [node];
    if (node.tagName !== "MOAST-PRODUCT") {
      if (node.querySelector) {
        var nested = node.querySelector("moast-product");
        if (nested) candidates.push(nested);
      }
      if (node.__moastCartTarget) candidates.push(node.__moastCartTarget);
    }

    var i;
    for (i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (!el) continue;

      var data = el.product || el._product || null;
      var handle =
        (data && (data.handle || data.productHandle)) ||
        el.handle ||
        el.getAttribute?.("product-handle") ||
        el.getAttribute?.("data-product-handle") ||
        el.getAttribute?.("product") ||
        "";

      if (typeof handle === "object" && handle) {
        handle = handle.handle || "";
      }

      var parsed = toProduct(String(handle || ""), "moast-node");
      if (parsed) return parsed;

      if (data && data.title) {
        var fromTitle = sanitizeProductTitle(data.title);
        if (fromTitle) {
          return { href: null, handle: null, title: fromTitle, source: "moast-title" };
        }
      }
    }

    return null;
  }

  function resolveProductFromComposedPath(event) {
    var results = [];
    var path = getComposedPath(event);

    path.forEach(function (node) {
      if (!(node instanceof Element)) return;
      if (node.tagName === "MOAST-PRODUCT" || node.tagName === "MOAST-PRODUCTS") {
        var fromNode = getProductDataFromMoastNode(node);
        if (fromNode && fromNode.handle) {
          results.push(fromNode);
        }
      }
      collectFromNode(node, results);
    });

    var product = pickBestProduct(results);
    if (product) product.source = product.source || "composed-path";
    return product;
  }

  function resolveProductForOpen(event) {
    var productEl = findProductElFromEvent(event);
    if (productEl) {
      return resolveProductFromElement(productEl).then(function (product) {
        if (product) return product;
        return resolveProductFromEventFallback(event);
      });
    }

    return resolveProductFromEventFallback(event);
  }

  function resolveProductFromEventFallback(event) {
    var fromPath = resolveProductFromComposedPath(event);
    if (fromPath && fromPath.handle) {
      return Promise.resolve(fromPath);
    }

    if (fromPath && fromPath.title) {
      return searchProductByTitle(fromPath.title);
    }

    var title = getTitleFromClick(event);
    if (title) {
      console.log("[moast-quickshop] 用标题搜索产品", title);
      return searchProductByTitle(title).then(function (searched) {
        return searched || null;
      });
    }

    return Promise.resolve(null);
  }

  function isInsideMoastWidget(event) {
    var block = getMoastBlock();
    var path = getComposedPath(event);

    if (isInsideMoastPlayer(event)) return true;

    if (block && event.target instanceof Element && block.contains(event.target)) {
      return true;
    }

    return path.some(function (node) {
      return (
        node instanceof Element &&
        ((block && (node === block || block.contains(node))) ||
          MOAST_TAGS.indexOf(node.tagName) >= 0)
      );
    });
  }

  function getMoastPlayer() {
    return document.querySelector("moast-player");
  }

  function isInsideMoastPlayer(event) {
    return getComposedPath(event).some(function (node) {
      if (!(node instanceof Element)) return false;
      if (node.tagName === "MOAST-PLAYER") return true;
      if (node.matches) {
        return node.matches(
          ".player-content, .bottom-bar, .bottom-bar__content, moast-products"
        );
      }
      return false;
    });
  }

  function getActiveSlideRect() {
    var carousel = getMoastCarousel();
    if (!carousel) return null;

    var deep = document.elementFromPoint(
      carousel.getBoundingClientRect().left + carousel.getBoundingClientRect().width * 0.5,
      carousel.getBoundingClientRect().top + carousel.getBoundingClientRect().height * 0.5
    );
    if (deep && deep.getBoundingClientRect) {
      var slideRect = deep.getBoundingClientRect();
      if (slideRect.width > 80 && slideRect.height > 120) {
        return slideRect;
      }
    }

    return carousel.getBoundingClientRect();
  }

  function getPlayerBottomBarRect(event) {
    var path = getComposedPath(event);
    var i;
    for (i = 0; i < path.length; i++) {
      var node = path[i];
      if (!(node instanceof Element) || !node.matches) continue;
      if (
        node.matches(
          ".bottom-bar, .bottom-bar__content, button.product, moast-product, moast-products"
        )
      ) {
        var rect = node.getBoundingClientRect();
        if (rect.width > 40 && rect.height > 20) return rect;
      }
    }

    var player = getMoastPlayer();
    if (!player) return null;
    var playerRect = player.getBoundingClientRect();
    if (!playerRect.width || !playerRect.height) return null;
    return {
      top: playerRect.top + playerRect.height * 0.72,
      left: playerRect.left,
      right: playerRect.right,
      bottom: playerRect.bottom,
      width: playerRect.width,
      height: playerRect.height * 0.28,
    };
  }

  function isMoastPlayerChromeClick(event) {
    // 播放器顶栏：缩小 / 静音 / 关闭；侧栏：分享 / 点赞 —— 绝不能当加购拦截
    var path = getComposedPath(event);
    var i;
    for (i = 0; i < path.length; i++) {
      var node = path[i];
      if (!(node instanceof Element)) continue;
      var label = String(
        (node.getAttribute && node.getAttribute("aria-label")) || ""
      ).toLowerCase();
      var title = String((node.getAttribute && node.getAttribute("title")) || "").toLowerCase();
      var cls = String(node.className || "").toLowerCase();
      if (
        /mute|unmute|volume|close|minimize|collapse|shrink|expand|share|like|heart|pip|picture/.test(
          label + " " + title + " " + cls
        )
      ) {
        return true;
      }
      if (node.matches) {
        if (
          node.matches(
            ".player-header, .player-controls, .top-bar, .top-controls, .header-actions," +
              " .mute, .unmute, .volume, .close, .minimize, .collapse, .share, .like"
          )
        ) {
          return true;
        }
      }
    }

    if (!isInsideMoastPlayer(event)) return false;
    var player = getMoastPlayer();
    if (!player) return false;
    var rect = player.getBoundingClientRect();
    if (!rect.height) return false;
    if (event.clientY <= rect.top + rect.height * 0.12) return true;
    if (event.clientX >= rect.right - Math.min(72, rect.width * 0.18)) {
      if (event.clientY < rect.top + rect.height * 0.72) return true;
    }
    return false;
  }

  function isInMoastProductBarZone(event) {
    if (isInsideMoastPlayer(event)) {
      if (isMoastPlayerChromeClick(event)) return false;
      var playerBar = getPlayerBottomBarRect(event);
      // 找不到底栏时不要把整屏都当成商品区（否则会误伤静音/关闭）
      if (!playerBar || !playerBar.height) return false;
      return (
        event.clientY >= playerBar.top - 8 &&
        event.clientY <= playerBar.bottom + 8
      );
    }

    var rect = getActiveSlideRect();
    if (!rect || !rect.height) return false;

    var y = event.clientY;
    var barTop = rect.top + rect.height * PRODUCT_BAR_TOP_RATIO;
    return y >= barTop && y <= rect.bottom + 4;
  }

  function isInMoastCartButtonZone(event) {
    if (isMoastPlayerChromeClick(event)) return false;
    if (!isInMoastProductBarZone(event)) return false;

    if (isInsideMoastPlayer(event)) {
      var playerBar = getPlayerBottomBarRect(event);
      if (!playerBar || !playerBar.width) return false;
      var playerCartLeft = playerBar.left + playerBar.width * 0.72;
      return event.clientX >= playerCartLeft && event.clientX <= playerBar.right + 8;
    }

    var rect = getActiveSlideRect();
    if (!rect || !rect.width) return false;

    var x = event.clientX;
    var cartLeft = rect.left + rect.width * CART_BUTTON_LEFT_RATIO;
    return x >= cartLeft && x <= rect.right + 4;
  }

  function isCartButtonElement(node) {
    if (!(node instanceof Element)) return false;

    if (node.matches) {
      if (
        node.matches(
          ".product__action, [class*='product__action'], .moast-theme-cart-btn"
        )
      ) {
        return true;
      }
    }

    if (node.tagName === "BUTTON" || node.getAttribute("role") === "button") {
      var cls = String(node.className || "");
      var label = String(node.getAttribute("aria-label") || "").toLowerCase();
      if (/cart|buy|add|shop|bag|quick.?add/i.test(cls + " " + label)) return true;
      // button.product 整块产品条不能整钮算作加购键，否则点文案也会被拦截
      if (node.matches && node.matches("button.product, .product")) return false;
      if (
        node.querySelector &&
        node.querySelector(
          ".product__action, [class*='product__action'], [class*='cart'], [class*='bag']"
        )
      ) {
        return false;
      }
    }

    if (node.matches) {
      return node.matches(
        '[class*="cart"], [class*="buy"], [class*="add-to-cart"], [class*="add_to_cart"], [class*="shopping"]'
      );
    }

    return false;
  }

  function isDirectCartActionClick(event) {
    var path = getComposedPath(event);
    var i;
    for (i = 0; i < path.length; i++) {
      var node = path[i];
      if (!(node instanceof Element) || !node.matches) continue;
      if (
        node.matches(
          ".product__action, [class*='product__action'], .moast-theme-cart-btn"
        )
      ) {
        return isInsideMoastPlayer(event) || isInMoastProductBarZone(event);
      }
    }
    // 不再用坐标热区兜底：iOS 上 pointerdown + preventDefault 会锁死上下/左右滑动
    return false;
  }

  function findProductElFromEvent(event) {
    var target = event.target;
    if (target instanceof Element && target.closest) {
      var overlay = target.closest(".moast-theme-cart-btn");
      if (overlay && overlay.__moastCartTarget) {
        return overlay.__moastCartTarget;
      }
    }

    var path = getComposedPath(event);
    var i, j, node;

    for (i = 0; i < path.length; i++) {
      node = path[i];
      if (!(node instanceof Element)) continue;
      if (node.tagName === "MOAST-PRODUCT") return node;
    }

    var targets = getMoastCartTargets();
    for (i = 0; i < path.length; i++) {
      node = path[i];
      if (!(node instanceof Element)) continue;

      for (j = 0; j < targets.length; j++) {
        if (targets[j] === node) return targets[j];
        if (targets[j].contains && targets[j].contains(node)) return targets[j];
      }
    }

    var x = event.clientX;
    var y = event.clientY;
    for (j = 0; j < targets.length; j++) {
      var rect = targets[j].getBoundingClientRect();
      if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) {
        return targets[j];
      }
    }

    return null;
  }

  function triggerCartQuickShopFromEvent(event) {
    var now = Date.now();
    if (now - lastBarActionAt < 800) return;
    lastBarActionAt = now;

    var productEl = findProductElFromEvent(event);
    if (productEl) {
      openQuickShopFromProductEl(productEl, event.target);
      return;
    }

    markCartButtonClickPending();
    resolveProductForOpen(event).then(function (product) {
      if (!product) {
        console.warn("[moast-quickshop] 点击购物车按钮，未解析到产品", {
          target: event.target,
          title: getTitleFromClick(event),
        });
        return;
      }

      var block = getMoastBlock();
      if (window.MoastTopicTracking?.trackClickFromTarget) {
        window.MoastTopicTracking.trackClickFromTarget(event.target, block);
      }

      openThemeQuickShop(product);
    });
  }

  function isMoastCartButtonClick(event) {
    var path = getComposedPath(event);
    var i;

    for (i = 0; i < path.length; i++) {
      if (isCartButtonElement(path[i])) {
        return isInsideMoastPlayer(event) || isInMoastProductBarZone(event);
      }
    }

    var target = event.target;
    if (target && target.closest) {
      var btn = target.closest(
        'button, [role="button"], [class*="cart"], [class*="buy"], [class*="add-to-cart"], [class*="shopping"]'
      );
      if (
        btn &&
        isCartButtonElement(btn) &&
        (isInsideMoastPlayer(event) || isInMoastProductBarZone(event))
      ) {
        return true;
      }
    }

    return isInMoastCartButtonZone(event);
  }

  function dismissMoastPanel() {
    [
      "moast-quick-add",
      "moast-product-panel",
      "moast-slide-out",
      "moast-product-details",
      "moast-drawer",
      "[class*='moast'][class*='slide-out']",
      "[class*='moast'][class*='slideout']",
      "[class*='moast'][class*='product-panel']",
      "[class*='moast'][class*='drawer']",
      "[class*='moast'][class*='quick-add']",
    ].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.closest(".quick_shop")) return;
        // 绝不能动全屏播放器本身
        if (el.tagName === "MOAST-PLAYER" || el.closest("moast-player")) return;
        el.style.setProperty("display", "none", "important");
        el.style.setProperty("visibility", "hidden", "important");
        el.style.setProperty("pointer-events", "none", "important");
        el.style.setProperty("opacity", "0", "important");
        if (typeof el.close === "function") {
          try {
            el.close();
          } catch (err) {}
        }
        if ("open" in el) {
          try {
            el.open = false;
          } catch (err2) {}
        }
        if (el.parentElement && el.parentElement.childElementCount === 1) {
          var parent = el.parentElement;
          if (
            parent.matches &&
            (parent.matches("[class*='moast']") || parent.tagName.indexOf("MOAST") === 0) &&
            parent.tagName !== "MOAST-PLAYER" &&
            !parent.closest("moast-player")
          ) {
            parent.style.setProperty("display", "none", "important");
            parent.style.setProperty("pointer-events", "none", "important");
          }
        }
      });
    });
  }

  function openThemeQuickShop(product) {
    if (!product || !isValidShopifyHandle(product.handle)) {
      console.warn("[moast-quickshop] 无效 handle", product);
      return false;
    }

    if (typeof window.quick_icon_click !== "function") {
      console.warn("[moast-quickshop] quick_icon_click 未加载");
      return false;
    }

    var now = Date.now();

    // 同一轮点击（pointerdown + moast-product-click）只打开一次
    if (openLock && now - lastOpenAt < 1200) {
      if (lastOpenKey === product.handle) return false;
    }

    if (window.quickShopLoading && !isThemeQuickShopOpen()) {
      window.quickShopLoading = false;
    }

    // 仅在主题快购确实处于打开态时才先关闭；避免误关导致刚打开又被清掉
    if (isThemeQuickShopOpen() && typeof window.closeQuickShopModal === "function") {
      window.closeQuickShopModal({ immediate: true });
    }

    openLock = true;
    lastOpenKey = product.handle;
    lastOpenAt = now;
    setTimeout(function () {
      openLock = false;
    }, 1200);

    window.quickShopMode = null;
    window.cartEditContext = null;

    var $trigger = window.jQuery
      ? window.jQuery('<span class="moast-quickshop-trigger"/>')
      : null;

    console.log("[moast-quickshop] 打开主题快购", product);
    document.body.classList.add("moast-theme-quickshop-active");
    injectHideMoastPanelCss();
    window.quick_icon_click($trigger, product.href, product.handle);
    dismissMoastPanel();
    startMoastPanelGuard();
    return true;
  }

  function getProductFromPanel(panel) {
    if (!panel) return null;

    var fromNode = getProductDataFromMoastNode(panel);
    if (fromNode && fromNode.handle) return fromNode;

    if (panel.product && panel.product.handle) {
      return toProduct(panel.product.handle, "panel-product");
    }

    try {
      var api = window.moastQuickAdd;
      var apiProduct =
        (api && api.product) ||
        (api && api.element && api.element.product) ||
        null;
      if (apiProduct && apiProduct.handle) {
        return toProduct(apiProduct.handle, "moastQuickAdd-api");
      }
    } catch (err) {}

    var link = panel.querySelector('a[href*="/products/"]');
    if (link) {
      return parseProductLink(link.getAttribute("href") || link.href, "panel-anchor");
    }

    var root = panel.shadowRoot;
    if (root) {
      var shadowLink = root.querySelector('a[href*="/products/"]');
      if (shadowLink) {
        return parseProductLink(
          shadowLink.getAttribute("href") || shadowLink.href,
          "panel-shadow-anchor"
        );
      }
      var shadowTitle = sanitizeProductTitle(
        root.querySelector(".product__title, h1, h2, h3")?.textContent || ""
      );
      if (shadowTitle) return { href: null, handle: null, title: shadowTitle, source: "panel-shadow-title" };
    }

    // closed shadow：用 composedPath 不可行；尝试 open 属性上的序列化
    var attrs = panel.getAttributeNames ? panel.getAttributeNames() : [];
    var i;
    for (i = 0; i < attrs.length; i++) {
      var parsed = parseHandleFromString(panel.getAttribute(attrs[i]), "panel-attr:" + attrs[i]);
      if (parsed) return parsed;
    }

    var html = panel.innerHTML || "";
    var match = html.match(/\/products\/([a-z0-9][a-z0-9-]*)/i);
    if (match) return toProduct(match[1], "panel-html");

    return null;
  }

  function openThemeQuickShopFromPanel(panel) {
    var product = getProductFromPanel(panel);
    if (product && product.handle) {
      openThemeQuickShop(product);
      return;
    }

    if (product && product.title) {
      searchProductByTitle(product.title).then(function (searched) {
        if (!searched || isThemeQuickShopOpen()) {
          dismissMoastPanel();
          return;
        }
        openThemeQuickShop(searched);
      });
      return;
    }

    var title = cleanProductTitle(
      panel.querySelector?.("h1,h2,h3,[class*='title']")?.textContent ||
        panel.textContent ||
        ""
    );
    if (sanitizeProductTitle(title)) {
      searchProductByTitle(title).then(function (searched) {
        if (!searched || isThemeQuickShopOpen()) {
          dismissMoastPanel();
          return;
        }
        openThemeQuickShop(searched);
      });
    }
  }

  function hijackMoastPanelOpen() {
    new MutationObserver(function (mutations) {
      // 播放器可能挂到 body：出现时再绑一次点击
      bindMoastPlayerClicks();

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;
          if (node.closest && node.closest(".quick_shop")) return;

          var panel =
            node.matches &&
            (node.matches(MOAST_PANEL_SELECTORS)
              ? node
              : node.querySelector && node.querySelector(MOAST_PANEL_SELECTORS));

          if (!panel) return;

          if (isThemeQuickShopOpen()) {
            dismissMoastPanel();
            return;
          }

          if (!cartButtonClickPending) return;

          dismissMoastPanel();
          startMoastPanelGuard();

          if (panelHijackLock) return;
          panelHijackLock = true;

          var tryOpen = function (attempt) {
            if (isThemeQuickShopOpen()) {
              panelHijackLock = false;
              dismissMoastPanel();
              return;
            }

            var product = getProductFromPanel(panel);
            if (product && product.handle) {
              panelHijackLock = false;
              dismissMoastPanel();
              openThemeQuickShop(product);
              return;
            }

            if (product && product.title) {
              searchProductByTitle(product.title).then(function (searched) {
                panelHijackLock = false;
                if (!searched || isThemeQuickShopOpen()) {
                  dismissMoastPanel();
                  return;
                }
                dismissMoastPanel();
                openThemeQuickShop(searched);
              });
              return;
            }

            var title = sanitizeProductTitle(
              panel.querySelector?.("h1,h2,h3,[class*='title']")?.textContent ||
                panel.shadowRoot?.querySelector?.(".product__title,h1,h2,h3")?.textContent ||
                panel.textContent ||
                ""
            );
            if (title.length >= 8) {
              searchProductByTitle(title).then(function (searched) {
                panelHijackLock = false;
                if (!searched || isThemeQuickShopOpen()) {
                  dismissMoastPanel();
                  return;
                }
                dismissMoastPanel();
                openThemeQuickShop(searched);
              });
              return;
            }

            if (attempt < 4) {
              setTimeout(function () {
                tryOpen(attempt + 1);
              }, 180);
              return;
            }

            panelHijackLock = false;
            dismissMoastPanel();
          };

          setTimeout(function () {
            tryOpen(0);
          }, 80);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function getProductFromMoastQuickAddInstance() {
    var panel =
      document.querySelector("moast-quick-add") ||
      null;

    try {
      var api = window.moastQuickAdd;
      if (api) {
        if (api.product && api.product.handle) {
          return toProduct(api.product.handle, "moastQuickAdd-api");
        }
        if (api.element && api.element.product && api.element.product.handle) {
          return toProduct(api.element.product.handle, "moastQuickAdd-element");
        }
        if (typeof api.getInstance === "function") {
          var inst = api.getInstance();
          if (inst && inst.product && inst.product.handle) {
            return toProduct(inst.product.handle, "moastQuickAdd-instance");
          }
        }
      }
    } catch (err) {}

    if (panel) return getProductFromPanel(panel);
    return null;
  }

  function bindMoastQuickAddEvents() {
    document.addEventListener(
      "moast-quick-add-open",
      function (event) {
        if (!cartButtonClickPending) return;

        dismissMoastPanel();
        startMoastPanelGuard();

        var panel =
          (event.target instanceof Element && event.target.tagName === "MOAST-QUICK-ADD"
            ? event.target
            : null) ||
          document.querySelector("moast-quick-add");

        if (isThemeQuickShopOpen()) {
          dismissMoastPanel();
          return;
        }

        // 产品数据可能异步写入，短重试
        var attempt = 0;
        var tryOpen = function () {
          if (isThemeQuickShopOpen()) {
            dismissMoastPanel();
            return;
          }

          var product =
            getProductFromPanel(panel) || getProductFromMoastQuickAddInstance();

          if (product && product.handle) {
            openThemeQuickShop(product);
            return;
          }

          if (product && product.title) {
            searchProductByTitle(product.title).then(function (searched) {
              if (searched && !isThemeQuickShopOpen()) {
                openThemeQuickShop(searched);
              } else {
                dismissMoastPanel();
              }
            });
            return;
          }

          attempt += 1;
          if (attempt < 10) {
            setTimeout(tryOpen, 100);
            return;
          }

          dismissMoastPanel();
          console.warn("[moast-quickshop] moast-quick-add 劫持未拿到产品");
        };

        setTimeout(tryOpen, 50);
      },
      true
    );

    // Moast 在 button 点击时同步派发；此时 this.product 可读，是最稳的入口
    document.addEventListener(
      "moast-product-click",
      function (event) {
        if (!isInsideMoastPlayer(event)) return;

        // pointerdown 已打开过则跳过，避免二次 close/open 把弹窗关掉
        if (openLock || isThemeQuickShopOpen() || window.quickShopLoading) {
          markCartButtonClickPending();
          dismissMoastPanel();
          return;
        }

        markCartButtonClickPending();
        startMoastPanelGuard();
        dismissMoastPanel();

        var path = getComposedPath(event);
        var fromPath = extractProductFromPath(path);
        var detail = event.detail || {};

        console.log("[moast-quickshop] moast-product-click", {
          handle: fromPath && fromPath.handle,
          title: fromPath && fromPath.title,
          productId: detail.productId || null,
        });

        function openFound(product) {
          if (!product) return false;
          if (product.handle) {
            openThemeQuickShop(product);
            return true;
          }
          if (product.title) {
            searchProductByTitle(product.title).then(function (searched) {
              if (searched && !isThemeQuickShopOpen()) {
                openThemeQuickShop(searched);
                dismissMoastPanel();
              }
            });
            return true;
          }
          return false;
        }

        if (openFound(fromPath)) return;

        var i;
        for (i = 0; i < path.length; i++) {
          var node = path[i];
          if (node && node.tagName === "MOAST-PRODUCT" && node.product) {
            if (openFound(extractProductFromPath([node]))) return;
          }
        }
      },
      true
    );
  }

  function extractProductFromPath(path) {
    if (!path || !path.length) return null;

    var i;
    for (i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node) continue;

      // Lit 组件实例上的 .product（即使在 closed shadow 的 composedPath 里也能读到）
      var data = node.product || node._product || null;
      if (data && typeof data === "object") {
        if (data.handle) {
          var byHandle = toProduct(String(data.handle), "path-product");
          if (byHandle) {
            byHandle.title = data.title || "";
            byHandle.id = data.id || null;
            return byHandle;
          }
        }
        if (data.title) {
          var t = sanitizeProductTitle(data.title) || cleanProductTitle(data.title).slice(0, 200);
          if (t && t.length >= 8) {
            return {
              href: null,
              handle: null,
              title: t,
              id: data.id || null,
              source: "path-product-title",
            };
          }
        }
      }

      if (node.tagName === "MOAST-PRODUCT") {
        var fromHost = getProductDataFromMoastNode(node);
        if (fromHost) return fromHost;
      }
    }

    return null;
  }

  function getTitleFromComposedPath(event) {
    var path = getComposedPath(event);
    var i;
    for (i = 0; i < path.length; i++) {
      var node = path[i];
      if (!(node instanceof Element)) continue;

      var className = "";
      try {
        className = String(node.getAttribute("class") || node.className || "");
      } catch (err) {
        className = "";
      }

      if (
        node.tagName === "BUTTON" &&
        (className.indexOf("product") >= 0 || (node.matches && node.matches("button.product")))
      ) {
        var btnTitle = getTitleFromProductButton(node);
        if (btnTitle) return btnTitle;
        // 不做过严 sanitize时也试一次短清理
        var rawBtn = cleanProductTitle(
          (function () {
            var clone = node.cloneNode(true);
            clone
              .querySelectorAll(".product__action, [class*='product__action'], svg")
              .forEach(function (el) {
                el.remove();
              });
            return clone.textContent || "";
          })()
        );
        if (rawBtn.length >= 8) return rawBtn.slice(0, 200);
      }

      if (
        className.indexOf("product__title") >= 0 ||
        className.indexOf("product__info") >= 0
      ) {
        var infoTitle =
          sanitizeProductTitle(node.textContent || "") ||
          cleanProductTitle(node.textContent || "").slice(0, 200);
        if (infoTitle.length >= 8) return infoTitle;
      }

      if (node.product && node.product.title) {
        var pTitle =
          sanitizeProductTitle(node.product.title) ||
          cleanProductTitle(node.product.title).slice(0, 200);
        if (pTitle.length >= 8) return pTitle;
      }
    }
    return "";
  }

  function resolveProductFromPlayerEvent(event) {
    var path = getComposedPath(event);
    var fromPath = extractProductFromPath(path);
    if (fromPath && fromPath.handle) {
      return Promise.resolve(fromPath);
    }

    var title =
      (fromPath && fromPath.title) ||
      getTitleFromComposedPath(event) ||
      "";

    if (title) {
      return searchProductByTitle(title).then(function (searched) {
        if (searched) return searched;
        return fromPath || null;
      });
    }

    // detail.productId（moast-product-click）兜底：用 id 再搜一遍标题
    var detail = event.detail || {};
    if (detail.productId) {
      return searchProductByTitle(String(detail.productId)).then(function (searched) {
        return searched || fromPath || null;
      });
    }

    return Promise.resolve(fromPath || null);
  }

  function openPlayerPlusQuickShop(event) {
    markCartButtonClickPending();
    startMoastPanelGuard();

    var now = Date.now();
    // 同一次点击的 pointerdown/mousedown 会连发：不可再 hard-block，否则会吃掉 click
    if (now - lastBarActionAt < 800) {
      return { blocked: false, opened: false, debounce: true };
    }
    lastBarActionAt = now;

    // 立刻冻结 path，避免异步后 composedPath 变空
    var path = getComposedPath(event).slice();
    var frozenEvent = {
      target: event.target,
      detail: event.detail,
      clientX: event.clientX,
      clientY: event.clientY,
      composedPath: function () {
        return path;
      },
    };

    var fromPath = extractProductFromPath(path);
    var title =
      (fromPath && fromPath.title) || getTitleFromComposedPath(frozenEvent) || "";

    console.log("[moast-quickshop] 视频弹窗加号", {
      handle: fromPath && fromPath.handle,
      title: title,
      productId: (fromPath && fromPath.id) || (event.detail && event.detail.productId) || null,
      pathTags: path
        .filter(function (n) {
          return n && n.tagName;
        })
        .slice(0, 12)
        .map(function (n) {
          return n.tagName;
        }),
    });

    if (fromPath && fromPath.handle) {
      openThemeQuickShop(fromPath);
      dismissMoastPanel();
      return { blocked: true, opened: true };
    }

    if (title) {
      // 有标题就硬拦 Moast，自己开主题快购
      searchProductByTitle(title).then(function (product) {
        if (product && !isThemeQuickShopOpen()) {
          openThemeQuickShop(product);
          dismissMoastPanel();
          return;
        }
        console.warn("[moast-quickshop] 视频弹窗标题搜索未命中", title);
      });
      return { blocked: true, opened: true };
    }

    // 没解析到：放行 Moast，靠 moast-product-click / moast-quick-add-open 劫持
    return { blocked: false, opened: false };
  }

  function blockMoastCartButtonPointer(event) {
    if (!isInsideMoastWidget(event)) return;
    if (isMoastPlayerChromeClick(event)) return;
    if (!isMoastCartButtonClick(event)) return;

    // 视频弹窗加号
    if (isInsideMoastPlayer(event) && isDirectCartActionClick(event)) {
      var result = openPlayerPlusQuickShop(event);
      if (result.blocked) {
        blockMoastNativeInteraction(event);
        dismissMoastPanel();
        return;
      }
      // 软拦截 / 防抖重入：不要 preventDefault / stopPropagation，
      // 否则 click 到不了 Moast，quick-add 建不起来，劫持也会失效
      markCartButtonClickPending();
      startMoastPanelGuard();
      return;
    }

    // 轮播：mousedown 不拦；pointerdown 仅在真正点到加购按钮时硬拦。
    // 坐标热区兜底不要在 pointerdown 上 preventDefault——iOS 会把整段滑动手势锁死。
    if (event.type === "mousedown") return;
    if (!isDirectCartActionClick(event)) return;

    markCartButtonClickPending();
    blockMoastNativeInteraction(event);
    dismissMoastPanel();
    startMoastPanelGuard();
    triggerCartQuickShopFromEvent(event);
  }

  function handleOverlayCartClick(event, productEl) {
    blockMoastNativeInteraction(event);
    dismissMoastPanel();

    var now = Date.now();
    if (now - lastBarActionAt < 800) return;
    lastBarActionAt = now;

    openQuickShopFromProductEl(productEl, event.currentTarget || event.target);
  }

  function createCartButton(productEl) {
    // fixed 浮层方案已废弃，保留空实现避免外部误调
    return null;
  }

  function stripHtmlToPlainText(value) {
    if (value == null) return "";
    var str = String(value);
    if (str.indexOf("<") === -1) return str.trim();
    var tmp = document.createElement("div");
    tmp.innerHTML = str;
    return (tmp.textContent || tmp.innerText || "").replace(/\s+/g, " ").trim();
  }

  function formatMoastMoney(cents) {
    var amount = Number(cents);
    if (!isFinite(amount)) return "";
    var format =
      (window.theme && window.theme.moneyFormat) ||
      (window.Shopify && window.Shopify.money_format) ||
      "${{amount}}";
    var formatted = "";
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      formatted = window.Shopify.formatMoney(amount, format);
    } else if (window.Currency && typeof window.Currency.formatMoney === "function") {
      formatted = window.Currency.formatMoney(amount, format);
    } else {
      formatted = "$" + (amount / 100).toFixed(2);
    }
    // Shopify.formatMoney 常返回 <span class="money">...</span>，必须转纯文本
    return stripHtmlToPlainText(formatted) || "$" + (amount / 100).toFixed(2);
  }

  function fetchProductJsonByHandle(handle) {
    if (!isValidShopifyHandle(handle)) return Promise.resolve(null);
    if (Object.prototype.hasOwnProperty.call(productJsonCache, handle)) {
      return productJsonCache[handle];
    }
    productJsonCache[handle] = fetch(
      "/products/" + encodeURIComponent(handle) + ".js"
    )
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
    return productJsonCache[handle];
  }

  function parseDisplayedPriceCents(text) {
    if (!text) return null;
    var match = String(text)
      .replace(/,/g, "")
      .match(/(\d+(?:\.\d+)?)/);
    if (!match) return null;
    return Math.round(parseFloat(match[1]) * 100);
  }

  /** 与主题 quick_icon_click 一致：variants[0] 为首档变体 */
  function getFirstTierVariant(productJson) {
    if (!productJson || !Array.isArray(productJson.variants) || !productJson.variants.length) {
      return null;
    }
    return productJson.variants[0];
  }

  function ensureMoastComparePriceNode(priceWrap, regularEl, compareText) {
    var plain = stripHtmlToPlainText(compareText);
    if (!plain) return null;

    var existing = priceWrap.querySelector("[data-moast-theme-compare]");
    if (existing) {
      // 相同文案不改 DOM，避免触发 MutationObserver 循环
      if (existing.textContent !== plain) existing.textContent = plain;
      return existing;
    }

    var span = document.createElement("span");
    span.className = "product__price-compare";
    span.setAttribute("data-moast-theme-compare", "1");
    span.textContent = plain;

    // 插在 regular 之后；避开 Lit 注释节点导致的错位
    if (regularEl && regularEl.parentNode === priceWrap) {
      var anchor = regularEl.nextSibling;
      while (
        anchor &&
        anchor.nodeType === 8 // Comment（Lit 占位注释）
      ) {
        anchor = anchor.nextSibling;
      }
      if (
        anchor &&
        anchor.nodeType === 1 &&
        anchor.classList &&
        (anchor.classList.contains("product__price-separator") ||
          anchor.classList.contains("product__price-max"))
      ) {
        priceWrap.insertBefore(span, anchor);
      } else if (anchor) {
        priceWrap.insertBefore(span, anchor);
      } else {
        priceWrap.appendChild(span);
      }
    } else {
      priceWrap.appendChild(span);
    }
    return span;
  }

  /** 把 Moast 最低价区间改成主题首档价（售价 + 划线价 = variants[0]） */
  function patchMoastComparePrice(productEl) {
    if (!productEl || comparePricePending.has(productEl)) return;
    var root = getShadowRootDeep(productEl);
    if (!root) return;
    var priceWrap = root.querySelector(
      ".product__price, .product_price, p.product__price, p.product_price"
    );
    if (!priceWrap) return;

    // 已成功补丁且 DOM 仍完整时跳过；若区间价又被 Moast 刷回来则重做
    if (productEl.__moastCompareDone) {
      var maxEl = priceWrap.querySelector(".product__price-max, .product__price-separator");
      var compareEl = priceWrap.querySelector("[data-moast-theme-compare]");
      var maxVisible =
        maxEl &&
        getComputedStyle(maxEl).display !== "none" &&
        getComputedStyle(maxEl).visibility !== "hidden";
      if (!maxVisible && (compareEl || priceWrap.querySelector(".product__price-regular"))) {
        if (!isMoastProductInsidePlayer(productEl)) {
          markMoastProductPriceReady(productEl);
        }
        return;
      }
      productEl.__moastCompareDone = false;
    }

    comparePricePending.add(productEl);
    resolveProductFromElement(productEl)
      .then(function (product) {
        if (!product || !product.handle) return null;
        return fetchProductJsonByHandle(product.handle);
      })
      .then(function (json) {
        if (!json) return;
        var first = getFirstTierVariant(json);
        if (!first) return;

        var stillRoot = getShadowRootDeep(productEl);
        var stillPrice =
          stillRoot &&
          stillRoot.querySelector(
            ".product__price, .product_price, p.product__price, p.product_price"
          );
        if (!stillPrice) return;

        // 保险：即使 CSS 未及时生效，也用 inline 藏掉区间最高价
        stillPrice
          .querySelectorAll(".product__price-max, .product__price-separator")
          .forEach(function (el) {
            setImportantStyleIfChanged(el, "display", "none");
          });

        var stillRegular = stillPrice.querySelector(".product__price-regular");
        var saleCents = Number(first.price);
        var compareAt = Number(first.compare_at_price || 0);
        if (!isFinite(saleCents) || saleCents <= 0) return;

        var saleText = formatMoastMoney(saleCents);
        if (stillRegular) {
          if (stripHtmlToPlainText(stillRegular.textContent) !== saleText) {
            stillRegular.textContent = saleText;
          }
          stillRegular.setAttribute("data-moast-theme-sale", "1");
          setImportantStyleIfChanged(stillRegular, "display", "inline");
          setImportantStyleIfChanged(stillRegular, "font-weight", "600");
          setImportantStyleIfChanged(stillRegular, "text-decoration", "none");
        }

        var existing = stillPrice.querySelector("[data-moast-theme-compare]");
        if (compareAt > saleCents) {
          ensureMoastComparePriceNode(
            stillPrice,
            stillRegular,
            formatMoastMoney(compareAt)
          );
        } else if (existing) {
          existing.remove();
        }
        productEl.__moastCompareDone = true;
        if (!isMoastProductInsidePlayer(productEl)) {
          markMoastProductPriceReady(productEl);
        }
      })
      .catch(function () {
        /* ignore */
      })
      .then(function () {
        comparePricePending.delete(productEl);
        // 请求失败/无划线价时也要揭开，避免商品条一直透明（仅轮播定制条）
        if (isMoastProductInsidePlayer(productEl)) return;
        if (!productEl.getAttribute || productEl.getAttribute("data-moast-theme-ready") !== "1") {
          var host = getMoastProductNode(productEl) || productEl;
          if (host && host.getAttribute && host.getAttribute("data-moast-theme-ready") !== "1") {
            markMoastProductPriceReady(productEl);
          }
        }
      });
  }

  function getMoastClipRect() {
    var carousel = getMoastCarousel();
    var clipEl = carousel || getMoastBlock();
    if (!clipEl) return null;
    var rect = clipEl.getBoundingClientRect();
    if (!rect.width || !rect.height) return null;
    return rect;
  }

  /** 商品条是否完全落在轮播可视区内；半露出则不应显示加购 */
  function isMoastProductFullyVisible(productEl) {
    var clipRect = getMoastClipRect();
    if (!clipRect) return true;

    var root = getShadowRootDeep(productEl);
    var productBtn = root && root.querySelector("button.product, .product");
    var barEl = productBtn || productEl;
    var barRect = barEl.getBoundingClientRect();
    if (!barRect.width || !barRect.height) return false;

    var tolerance = 2;
    return (
      barRect.left >= clipRect.left - tolerance &&
      barRect.right <= clipRect.right + tolerance
    );
  }

  function setMoastNativeActionVisible(productEl, visible) {
    var root = getShadowRootDeep(productEl);
    var action = root && root.querySelector(".product__action");
    if (!action) return;
    // 始终保持原生加购可见并随卡片滚动；不再用滚动显隐（会抖）
    setImportantStyleIfChanged(action, "display", "flex");
    setImportantStyleIfChanged(action, "visibility", "visible");
    setImportantStyleIfChanged(action, "opacity", "1");
    setImportantStyleIfChanged(action, "pointer-events", "auto");
  }

  function getMoastCartButtonRect(productEl) {
    // 浮层定位已废弃
    return null;
  }

  function updateCartButtonPosition(productEl, btn) {
    // 浮层定位已废弃；确保原生按钮保持可见
    setMoastNativeActionVisible(productEl, true);
    if (btn) btn.style.display = "none";
  }

  function injectCarouselUnreadyHideCss() {
    var carousel = getMoastCarousel();
    var root = carousel && carousel.shadowRoot;
    if (!root) return;

    var style = root.getElementById("moast-theme-unready-hide");
    if (!style) {
      style = document.createElement("style");
      style.id = "moast-theme-unready-hide";
      root.appendChild(style);
    }
    if (style.dataset.moastCssVer === "unready-v5") return;
    style.dataset.moastCssVer = "unready-v5";
    // 必须写在 carousel shadow 内：document 样式穿不进 Shadow
    style.textContent =
      "moast-product:not([data-moast-theme-ready='1']) {" +
      "  opacity: 0 !important;" +
      "  visibility: hidden !important;" +
      "  pointer-events: none !important;" +
      "}" +
      "moast-product[data-moast-theme-ready='1'] {" +
      "  opacity: 1 !important;" +
      "  visibility: visible !important;" +
      "  pointer-events: auto !important;" +
      "}";
  }

  function syncMoastCartButtons() {
    applyMoastCardThemeVars();
    injectCarouselUnreadyHideCss();
    var products = getMoastCartTargets();
    var patched = 0;

    products.forEach(function (productEl) {
      var inPlayer = isMoastProductInsidePlayer(productEl);
      if (!inPlayer) hideMoastProductUntilReady(productEl);
      if (patchMoastProductShadow(productEl)) patched += 1;
      if (!inPlayer) setMoastNativeActionVisible(productEl, true);
    });

    // 清理历史 fixed 浮层（含滚动中残留的鬼影图标）
    document.querySelectorAll(".moast-theme-cart-btn").forEach(function (btn) {
      btn.remove();
    });

    return { total: products.length, patched: patched };
  }

  function scheduleSyncMoastCartButtons() {
    if (cartButtonSyncRaf) return;
    cartButtonSyncRaf = requestAnimationFrame(function () {
      cartButtonSyncRaf = 0;
      syncMoastCartButtons();
    });
  }

  function observeMoastRootForSync(root, observedRoots) {
    if (!root || observedRoots.has(root)) return;
    observedRoots.add(root);
    new MutationObserver(function (mutations) {
      // 新商品卡出现时立刻同步补丁（不能 debounce，否则首帧会露出 Moast 默认区间价）
      var needSync = false;
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (!(node instanceof Element)) continue;
          if (
            node.tagName === "MOAST-PRODUCT" ||
            (node.querySelector && node.querySelector("moast-product"))
          ) {
            needSync = true;
            break;
          }
        }
        if (needSync) break;
      }
      if (needSync) {
        syncMoastCartButtons();
      } else {
        scheduleSyncMoastCartButtons();
      }
    }).observe(root, {
      childList: true,
      subtree: true,
    });
  }

  function bindMoastCartButtonSync() {
    var block = getMoastBlock();
    var carousel = getMoastCarousel();
    var player = document.querySelector("moast-player");
    if (!block && !carousel && !player) return;
    if (bindMoastCartButtonSync.__bound) {
      scheduleSyncMoastCartButtons();
      return;
    }
    bindMoastCartButtonSync.__bound = true;

    syncMoastProductShadows();
    scheduleSyncMoastCartButtons();

    window.addEventListener("resize", scheduleSyncMoastCartButtons, { passive: true });

    var observedRoots = new WeakSet();
    observeMoastRootForSync(block, observedRoots);
    observeMoastRootForSync(carousel, observedRoots);
    if (carousel && carousel.shadowRoot) {
      observeMoastRootForSync(carousel.shadowRoot, observedRoots);
    }
    observeMoastRootForSync(player, observedRoots);
    if (player && player.shadowRoot) {
      observeMoastRootForSync(player.shadowRoot, observedRoots);
    }

    // 商品卡异步进 Shadow：持续补丁直到成功，再做几次收尾
    var resyncCount = 0;
    var successStreak = 0;
    var resyncTimer = setInterval(function () {
      resyncCount += 1;
      carousel = getMoastCarousel();
      player = document.querySelector("moast-player");
      if (carousel && carousel.shadowRoot) {
        observeMoastRootForSync(carousel.shadowRoot, observedRoots);
      }
      if (player && player.shadowRoot) {
        observeMoastRootForSync(player.shadowRoot, observedRoots);
      }
      var result = syncMoastCartButtons();
      if (result && result.patched > 0) successStreak += 1;
      if (successStreak >= 3 || resyncCount >= 40) clearInterval(resyncTimer);
    }, 500);

    if (carousel) {
      var bindEmbla = function () {
        var embla = carousel._carousel;
        if (!embla || typeof embla.on !== "function" || carousel.__moastCartEmblaBound) {
          return !!embla;
        }
        carousel.__moastCartEmblaBound = true;
        ["select", "reInit", "settle"].forEach(function (evt) {
          embla.on(evt, scheduleSyncMoastCartButtons);
        });
        return true;
      };

      if (!bindEmbla()) {
        var emblaWait = 0;
        var emblaTimer = setInterval(function () {
          emblaWait += 1;
          if (bindEmbla() || emblaWait >= 40) clearInterval(emblaTimer);
        }, 250);
      }
    }
  }

  // 供 moast-layout 在布局完成后再触发一次补丁
  window.__moastQuickShopResync = scheduleSyncMoastCartButtons;

  function handleMoastCartButtonClick(event) {
    if (event.target instanceof Element && event.target.closest(".moast-theme-cart-btn")) {
      return;
    }
    if (!isInsideMoastWidget(event)) return;
    if (isMoastPlayerChromeClick(event)) return;
    if (!isMoastCartButtonClick(event)) return;
    if (isDirectCartActionClick(event)) return;

    blockMoastNativeInteraction(event);
    dismissMoastPanel();
    markCartButtonClickPending();

    var now = Date.now();
    if (now - lastBarActionAt < 800) return;
    lastBarActionAt = now;

    resolveProductForOpen(event).then(function (product) {
      if (!product) {
        console.warn("[moast-quickshop] 点击购物车按钮，标题搜索未命中", {
          target: event.target,
          title: getTitleFromClick(event),
        });
        return;
      }

      var block = getMoastBlock();
      if (window.MoastTopicTracking?.trackClickFromTarget) {
        window.MoastTopicTracking.trackClickFromTarget(event.target, block);
      }

      openThemeQuickShop(product);
    });
  }

  function bindElementClick(el) {
    if (!el || el.dataset.moastQuickShopBound) return;
    el.dataset.moastQuickShopBound = "1";
    el.addEventListener("pointerdown", blockMoastCartButtonPointer, true);
    el.addEventListener("mousedown", blockMoastCartButtonPointer, true);
    el.addEventListener("click", handleMoastCartButtonClick, true);
  }

  function bindMoastPlayerClicks() {
    var player = document.querySelector("moast-player");
    if (player) bindElementClick(player);
  }

  function initMoastQuickShop() {
    var block = getMoastBlock();
    var carousel = getMoastCarousel();
    if (!block && !carousel) return false;

    applyMoastCardThemeVars();
    if (block) bindElementClick(block);
    if (carousel) bindElementClick(carousel);
    bindMoastPlayerClicks();
    return true;
  }

  function bindQuickShopCloseWatcher() {
    document.addEventListener(
      "click",
      function (event) {
        if (!(event.target instanceof Element)) return;
        if (
          !event.target.closest(
            ".quick_shop .window-cover, .quick_shop .window-cover_con-close"
          )
        ) {
          return;
        }
        setTimeout(resetMoastQuickShopLocks, 250);
      },
      true
    );

    var quickShop = document.querySelector(".quick_shop");
    if (!quickShop) return;

    new MutationObserver(function () {
      if (quickShop.getAttribute("aria-hidden") === "true") {
        resetMoastQuickShopLocks();
      }
    }).observe(quickShop, {
      attributes: true,
      attributeFilter: ["aria-hidden"],
    });
  }

  function waitAndInit() {
    injectHideMoastPanelCss();
    injectMoastCartButtonCss();
    injectCarouselUnreadyHideCss();
    watchMoastPlayerOpenState();
    refreshCartButtonIcons();
    hijackMoastPanelOpen();
    bindMoastQuickAddEvents();
    bindQuickShopCloseWatcher();
    // 不要挂 document 级 pointerdown：iOS 会对整页触控做可取消监听等待，易整页卡死。
    // 只绑在 Moast 区块上（见 initMoastQuickShop → bindElementClick）。

    if (initMoastQuickShop()) {
      bindMoastCartButtonSync();
      return;
    }

    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      injectCarouselUnreadyHideCss();
      syncMoastPlayerOpenClass();
      if (initMoastQuickShop()) {
        bindMoastCartButtonSync();
        clearInterval(timer);
        return;
      }
      if (attempts >= 60) {
        clearInterval(timer);
      }
    }, 500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", waitAndInit);
  } else {
    waitAndInit();
  }

  window.MoastQuickShopDebug = function () {
    var products = getMoastCartTargets();
    return {
      block: getMoastBlock(),
      carousel: getMoastCarousel(),
      targetCount: products.length,
      overlayCount: document.querySelectorAll(".moast-theme-cart-btn").length,
      mode: "native-product-action",
      targets: products.map(function (el) {
        var action = getMoastProductAction(el);
        return {
          tag: el.tagName,
          className: el.className,
          hasShadow: !!getShadowRootDeep(el),
          actionVisible: isMoastActionVisible(action),
          fullyVisible: isMoastProductFullyVisible(el),
          rect: el.getBoundingClientRect(),
        };
      }),
    };
  };
})();
